<div class="comments">
  <div class="comments__container">
    <p class="comments__title">{{ lg.commentsBlock.trackComments }}: <span class="comments__count">0</span></p>
    <p class="comments__beatmaker-name">{{ beatmakerName }}</p>
  </div>
  <bmcore-textarea placeholder="{{ lg.textarea.message }}"></bmcore-textarea>
  <bmcore-button title="{{ lg.button.leaveComment }}" icon="btv-icon-btn-message"> </bmcore-button>
</div>
